<button class="new-chat-button" type="button">
    <span class="new-chat-button__icon" aria-hidden="true">+</span
    ><span class="new-chat-button__text"> New Chat </span>
</button>
